export default __webpack_public_path__ + "static/media/left.adc015eb.svg";